// Merges a bulk-post chunk's response into the running result. A statement larger than the
// backend's per-batch cap (a month of BCA is ~590 rows against a 400 limit) is posted in
// several chunks; every chunk after the first accumulates so the review screen reports the
// whole import rather than just the final slice.
//
// Pulled out of the reducer so it can be unit-tested without importing the axios-bound
// redux module (CRA's jest does not transform axios's ESM build).
export type BulkSummary = { posted: number; duplicate: number; failed: number };
export type BulkResult = {
  success?: boolean;
  results?: any[];
  summary?: BulkSummary;
  [k: string]: any;
};

export function mergeBulkResult(
  previous: BulkResult | null,
  incoming: BulkResult | null,
  accumulate: boolean
): BulkResult | null {
  if (!accumulate || !previous?.summary || !incoming?.summary) return incoming;
  return {
    ...incoming,
    success: Boolean(previous.success) && Boolean(incoming.success),
    results: [...(previous.results ?? []), ...(incoming.results ?? [])],
    summary: {
      posted: (previous.summary.posted ?? 0) + (incoming.summary.posted ?? 0),
      duplicate: (previous.summary.duplicate ?? 0) + (incoming.summary.duplicate ?? 0),
      failed: (previous.summary.failed ?? 0) + (incoming.summary.failed ?? 0),
    },
  };
}
